module.exports = __webpack_public_path__ + "static/media/Logo-color.3dc0e8d8.png";